/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetUserHashedEmail2QueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserHashedEmail2Query = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    b2bProfileSettings?: {
      __typename?: 'B2BProfileSettings';
      hashedEmail?: string | null;
    } | null;
  } | null;
};

export const GetUserHashedEmail2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserHashedEmail2' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'b2bProfileSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hashedEmail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserHashedEmail2Query,
  GetUserHashedEmail2QueryVariables
>;
